import i18n from '@/lib/i18n';
import { I18nNamespace } from '@/lib/i18n-namespaces';

export const MILLISECONDS_TO_SECONDS = 1000;
export const SECONDS_IN_MINUTE = 60;
export const SECONDS_IN_HOUR = 3600;
export const SECONDS_IN_DAY = 86400;
export const MILLISECONDS_IN_MINUTE =
    SECONDS_IN_MINUTE * MILLISECONDS_TO_SECONDS;
export const MILLISECONDS_IN_HOUR = SECONDS_IN_HOUR * MILLISECONDS_TO_SECONDS;
export const MILLISECONDS_IN_DAY = SECONDS_IN_DAY * MILLISECONDS_TO_SECONDS;

export const HOURS_IN_DAY = 24;
export const DAYS_IN_WEEK = 7;
export const DAYS_IN_MONTH = 30;
export const DAYS_IN_YEAR = 365;

export const STREAMING_TIMING = {
    DEFAULT_VOD_WINDOW_MS: 60 * 1000,
    VOD_OFFSET_FROM_LIVE_SEC: 5 * 60,
    FALLBACK_SEEK_OFFSET_SEC: 60 * 60,
    LIVE_STATUS_POLL_MS: 5000,
    ARCHIVE_REFRESH_MS: 5000,
    ARCHIVE_START_TOLERANCE_MS: 5 * 60 * 1000,
    RECENT_FOOTAGE_TOLERANCE_MS: 5 * 60 * 1000,
} as const;

export const STREAMING_ERRORS = {
    get NO_RECORDING() {
        return i18n.t('streaming.errors.noRecording', {
            ns: I18nNamespace.VIDEO,
        });
    },
    get INVALID_TIMESTAMPS() {
        return i18n.t('streaming.errors.invalidTimestamps', {
            ns: I18nNamespace.VIDEO,
        });
    },
    get LOAD_FAILED() {
        return i18n.t('streaming.errors.loadFailed', {
            ns: I18nNamespace.VIDEO,
        });
    },
    get LIVE_STATUS_FAILED() {
        return i18n.t('streaming.errors.liveStatusFailed', {
            ns: I18nNamespace.VIDEO,
        });
    },
} as const;
